import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1109.000000 1116.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1116.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5045 9419 c-193 -18 -349 -39 -465 -63 -178 -35 -233 -47 -250 -54
-8 -3 -37 -11 -65 -17 -57 -14 -246 -75 -320 -103 -87 -34 -223 -91 -242 -101
-10 -5 -61 -30 -113 -56 -120 -57 -219 -111 -293 -158 -31 -20 -59 -37 -62
-37 -4 0 -86 -55 -188 -127 -258 -181 -559 -466 -774 -733 -104 -130 -313
-434 -313 -457 0 -3 -9 -18 -20 -33 -25 -35 -180 -345 -210 -420 -12 -30 -28
-68 -35 -85 -28 -63 -85 -232 -124 -365 -12 -41 -26 -88 -31 -105 -5 -16 -23
-102 -40 -190 -17 -88 -35 -182 -41 -210 -5 -27 -14 -99 -19 -160 -6 -60 -15
-157 -21 -215 -13 -120 -6 -485 11 -630 27 -228 51 -371 94 -555 32 -138 85
-315 98 -329 4 -6 8 -17 8 -26 0 -14 62 -183 89 -245 5 -11 19 -42 31 -70 37
-85 132 -278 155 -315 12 -19 33 -55 47 -80 95 -169 297 -450 421 -587 17 -19
43 -47 56 -62 466 -521 1099 -926 1776 -1136 82 -25 179 -53 215 -61 181 -41
249 -53 362 -68 68 -9 148 -21 178 -26 89 -15 502 -22 670 -11 232 14 496 51
650 91 19 5 81 20 138 35 477 121 1045 409 1417 716 11 9 61 50 110 91 91 75
312 289 376 363 19 22 59 69 90 105 31 36 85 103 121 150 65 86 248 355 248
365 0 3 12 24 26 46 93 147 254 507 318 709 15 47 31 94 36 105 29 68 96 374
140 640 16 96 35 378 35 535 0 293 -38 637 -103 938 -68 310 -240 742 -423
1062 -174 304 -451 649 -724 900 -350 322 -658 522 -1125 733 -273 123 -760
251 -1095 288 -259 28 -628 37 -820 18z m575 -249 c240 -15 502 -55 690 -106
52 -14 113 -30 135 -35 72 -17 366 -124 454 -165 250 -117 350 -173 581 -322
196 -127 572 -460 725 -642 253 -300 422 -568 580 -919 52 -116 61 -141 115
-301 56 -167 69 -216 119 -455 67 -318 87 -735 51 -1080 -20 -200 -40 -341
-59 -425 -5 -25 -15 -67 -20 -95 -43 -210 -169 -562 -282 -788 -198 -394 -414
-692 -725 -999 -332 -327 -692 -574 -1089 -748 -27 -12 -63 -28 -80 -36 -88
-40 -374 -137 -470 -159 -333 -79 -500 -103 -775 -115 -358 -14 -695 12 -980
75 -63 14 -133 30 -155 34 -88 18 -377 116 -482 162 -23 11 -44 19 -47 19 -6
0 -245 116 -276 134 -14 8 -59 34 -100 57 -128 71 -349 223 -490 335 -173 139
-426 392 -563 564 -498 624 -759 1294 -808 2075 -41 658 95 1352 374 1910 120
238 308 537 406 643 17 18 31 35 31 38 0 8 116 142 198 227 126 132 356 331
486 422 31 22 82 58 114 81 76 54 275 171 387 227 591 296 1263 429 1955 387z"
          />
          <path
            d="M4875 8215 c-161 -26 -212 -38 -310 -73 -203 -73 -356 -191 -468
-361 -37 -57 -56 -94 -107 -216 -4 -11 -13 -42 -20 -70 -6 -27 -17 -68 -23
-90 -8 -25 -12 -109 -11 -225 0 -165 3 -193 24 -255 46 -142 94 -228 171 -309
l47 -50 114 38 c279 91 605 86 913 -15 110 -37 281 -121 355 -176 80 -59 94
-71 150 -124 156 -150 264 -353 291 -547 49 -342 -146 -557 -543 -601 -54 -6
-118 -11 -142 -11 l-45 0 -27 -57 c-105 -223 -268 -333 -496 -333 -79 0 -182
39 -263 100 -85 63 -171 197 -194 300 -26 112 -7 282 40 367 44 79 120 163
173 190 17 8 38 21 46 27 26 21 122 48 192 53 144 12 297 -46 405 -154 66 -66
84 -94 117 -188 33 -92 38 -99 82 -97 26 1 46 10 66 29 24 23 28 35 28 78 0
97 -56 228 -135 316 -36 40 -128 119 -139 119 -4 0 -21 9 -38 21 -16 12 -63
34 -105 50 -119 46 -336 51 -438 10 -197 -80 -294 -170 -391 -365 -62 -124
-90 -156 -137 -156 -50 0 -91 49 -83 100 23 146 74 268 157 379 55 73 193 182
280 220 186 81 202 85 399 85 159 1 181 -1 245 -23 69 -23 225 -96 235 -110 3
-3 28 -24 57 -45 115 -86 220 -237 274 -391 45 -129 87 -161 146 -111 23 20
27 31 26 68 -2 24 -12 75 -24 113 -23 76 -87 218 -101 223 -4 2 -8 9 -8 14 0
19 -82 121 -150 186 -112 108 -231 181 -375 230 -126 44 -214 55 -384 50 -120
-4 -161 -9 -231 -31 -148 -45 -188 -63 -303 -141 -77 -52 -207 -176 -207 -199
0 -4 -8 -17 -19 -28 -27 -30 -76 -134 -101 -219 -12 -41 -26 -88 -31 -105 -15
-47 -23 -264 -11 -320 53 -262 172 -441 389 -586 143 -95 295 -149 543 -193
268 -49 752 -47 975 3 107 25 174 43 210 57 22 9 56 23 75 31 219 90 421 278
509 475 43 96 51 118 77 213 23 88 26 120 27 260 0 90 -5 186 -12 220 -16 75
-65 225 -93 279 -92 181 -252 328 -466 428 -109 51 -507 179 -599 194 -24 4
-43 10 -43 14 0 4 -20 10 -45 13 -25 4 -66 13 -93 21 -26 8 -101 31 -167 51
-168 51 -296 115 -360 179 -65 65 -88 114 -93 196 -6 98 24 168 102 246 125
123 316 173 612 160 292 -12 443 -95 487 -268 7 -29 19 -53 25 -52 7 1 163 2
347 3 l335 1 0 40 c0 119 -42 276 -104 390 -39 71 -190 240 -215 240 -5 0 -16
6 -24 14 -25 26 -160 91 -242 118 -155 50 -256 71 -424 88 -141 14 -606 11
-706 -5z"
          />
          <path
            d="M4715 5502 c-86 -31 -139 -84 -170 -171 -19 -56 -19 -85 2 -144 23
-64 74 -122 134 -152 161 -82 360 55 342 235 -13 137 -99 227 -228 235 -33 2
-69 1 -80 -3z"
          />
          <path
            d="M5490 4023 c-175 -61 -255 -240 -203 -458 21 -89 83 -164 168 -205
74 -35 191 -39 270 -10 77 29 156 106 174 170 13 47 12 197 -1 193 -5 -2 -70
-3 -145 -3 l-138 0 0 -47 c0 -27 5 -51 10 -55 6 -4 41 -8 78 -8 66 0 68 -1 61
-22 -15 -52 -36 -77 -77 -97 -72 -35 -159 -21 -203 33 -13 17 -30 38 -37 46
-8 9 -12 51 -12 120 0 121 14 161 71 198 73 48 159 38 214 -25 l32 -36 64 32
c35 18 64 38 64 45 0 20 -91 100 -130 115 -19 7 -43 17 -52 22 -27 14 -158 9
-208 -8z"
          />
          <path
            d="M2634 4019 c-118 -28 -179 -169 -124 -285 25 -50 73 -85 155 -113
136 -45 155 -62 139 -125 -15 -61 -169 -59 -236 4 -12 11 -25 20 -30 20 -4 0
-25 -19 -47 -42 l-40 -43 27 -28 c48 -51 127 -80 217 -81 123 -2 187 25 236
100 14 22 19 47 19 99 0 113 -41 160 -190 215 -92 34 -130 62 -130 95 0 64
113 88 189 40 22 -13 42 -29 46 -35 3 -5 10 -10 14 -10 9 0 71 87 71 99 0 14
-61 62 -97 78 -43 18 -167 25 -219 12z"
          />
          <path
            d="M3188 3918 c-20 -57 -49 -134 -63 -173 -15 -38 -40 -106 -55 -150
-16 -44 -42 -118 -59 -164 -17 -46 -31 -85 -31 -87 0 -2 31 -4 69 -4 78 0 77
-1 106 78 l20 54 124 0 c68 -1 128 -5 133 -10 4 -4 16 -33 26 -63 l17 -54 78
-3 c62 -2 78 0 74 10 -3 7 -14 38 -24 68 -9 30 -20 57 -23 60 -3 3 -11 21 -17
40 -6 19 -30 87 -53 150 -23 63 -48 133 -55 155 -21 63 -63 174 -70 185 -3 6
-41 10 -84 10 l-77 0 -36 -102z m132 -96 c0 -9 16 -59 35 -111 19 -51 32 -97
29 -102 -5 -9 -147 -13 -156 -4 -2 3 11 53 30 112 19 60 36 114 38 121 5 18
24 5 24 -16z"
          />
          <path
            d="M3533 4008 c10 -25 37 -97 118 -308 45 -118 94 -246 109 -285 l27
-70 73 0 73 0 63 165 c35 91 68 173 74 182 5 10 10 26 10 36 0 10 4 22 8 27 5
6 14 24 20 40 6 17 27 72 46 122 20 51 36 95 36 98 0 3 -33 5 -73 5 -85 0 -71
16 -137 -156 -73 -194 -78 -208 -96 -266 -10 -32 -20 -58 -23 -58 -3 0 -21 46
-39 103 -19 56 -40 116 -47 132 -8 17 -26 62 -40 100 -15 39 -34 87 -44 107
l-16 37 -74 1 c-54 0 -72 -3 -68 -12z"
          />
          <path d="M4280 3680 l0 -341 70 3 70 3 1 335 2 335 -72 3 -71 3 0 -341z" />
          <path
            d="M4580 3680 l0 -340 75 0 75 0 0 215 c0 137 4 215 10 215 6 0 10 -8
11 -17 1 -25 14 -45 192 -301 l79 -113 72 3 71 3 0 335 0 335 -72 3 -73 3 -2
-223 c-3 -206 -4 -221 -18 -193 -8 17 -73 117 -144 223 l-129 192 -74 0 -73 0
0 -340z"
          />
          <path
            d="M6010 3682 c0 -188 3 -343 8 -345 4 -3 81 -1 172 3 195 10 239 22
313 90 69 63 97 134 99 251 3 156 -59 256 -197 315 -31 14 -78 19 -217 22
l-178 4 0 -340z m317 192 c42 -6 90 -47 108 -91 22 -52 19 -160 -4 -209 -36
-73 -85 -96 -192 -92 l-74 3 0 195 c0 107 1 199 3 203 3 7 83 3 159 -9z"
          />
          <path
            d="M6875 4008 c-2 -7 -14 -42 -26 -78 -12 -36 -27 -78 -35 -95 -7 -16
-19 -50 -28 -75 -8 -25 -24 -70 -36 -100 -11 -30 -34 -91 -49 -135 -16 -44
-36 -97 -45 -119 -27 -63 -24 -66 54 -66 67 0 71 1 81 28 21 51 27 67 33 85 5
15 20 17 130 17 140 0 135 3 161 -85 l12 -40 77 -3 c42 -2 76 -1 76 1 0 3 -18
56 -41 118 -46 131 -47 132 -124 339 -32 85 -61 169 -64 185 l-7 30 -82 3
c-60 2 -84 -1 -87 -10z m99 -190 c3 -18 20 -69 36 -113 16 -44 30 -86 30 -92
0 -9 -23 -13 -80 -13 -51 0 -80 4 -80 11 0 6 13 50 29 97 16 48 32 99 35 115
8 37 22 34 30 -5z"
          />
          <path
            d="M7230 3956 l0 -65 93 -3 92 -3 1 -270 1 -270 71 -3 72 -3 2 273 3
273 90 5 90 5 0 60 0 60 -257 3 -258 2 0 -64z"
          />
          <path
            d="M7940 3994 c-6 -14 -10 -28 -10 -31 0 -10 -90 -258 -100 -275 -6 -10
-10 -23 -10 -29 0 -6 -6 -25 -14 -42 -20 -44 -96 -257 -96 -268 0 -5 32 -9 70
-9 l71 0 18 43 c10 23 21 53 24 67 l6 25 128 -3 c83 -3 131 -8 135 -15 5 -7
13 -30 19 -52 17 -60 24 -65 101 -65 62 0 70 2 65 18 -5 18 -62 174 -122 337
-20 55 -39 109 -42 120 -3 11 -11 34 -19 52 -8 17 -14 34 -14 37 0 3 -9 30
-21 61 l-20 55 -80 0 c-76 0 -80 -1 -89 -26z m100 -163 c0 -10 16 -61 35 -112
19 -52 35 -100 35 -106 0 -9 -23 -13 -80 -13 -44 0 -80 3 -80 8 -1 4 16 60 37
124 36 110 53 143 53 99z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
